export const CUSTOMER_LIST ="CUSTOMER_LIST"